import { request } from '@umijs/max';

const post = <T>(path: string, data?: Record<string, unknown>) =>
  request<API.ApiResponse<T>>(`/api/admincp/printjobs/${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: data || {},
  });

export const printJobPage = (body: API.PrintJobPageParams) =>
  post<API.PrintJobPageResult>('page', body as Record<string, unknown>);

export const printJobStats = () => post<API.PrintJobStats>('stats');

export const printJobAttempts = (id: number) =>
  post<API.PrintJobAttemptsResult>('attempts', { id });

export const retryPrintJob = (id: number) =>
  post<string>('retry', { id });

export const reprintPrintJob = (id: number) =>
  post<{ id: number; message: string }>('reprint', { id });

export const resolvePrintJob = (id: number, note: string) =>
  post<string>('resolve', { id, note });
